const map = {
	"./badge-google-play-bg.webp": 6656,
	"./badge-google-play-cs.webp": 42009,
	"./badge-google-play-de-AT.webp": 40162,
	"./badge-google-play-hr.webp": 50953,
	"./badge-google-play-hu.webp": 99632,
	"./badge-google-play-ro.webp": 99544,
	"./badge-google-play-sk.webp": 48001
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57507;